export default "__VITE_ASSET__195d1570__"